import { RestrictedScreen } from 'component/admin';
import { UtilityText } from 'component/text';
import { componentWithVariants, demoFile, variant } from 'system/demo';

function RestrictedScreenDemo(props) {
    return (
        <RestrictedScreen {...props}>
            <UtilityText text='Secret content' />
        </RestrictedScreen>
    );
}

demoFile('component/admin');

componentWithVariants('RestrictedScreen', RestrictedScreenDemo, {}, [
    variant('Allowed', {
        state: { roles: ['Owner'] },
        args: { capability: 'any' },
    }),
    variant('Denied', {
        state: { roles: [] },
        args: { capability: 'any' },
    }),
]);
